


















import { Vue, Component, Prop } from 'vue-property-decorator';
import SortIcon from '../icons/SortIcon.vue';
import { SortingOption } from '@/store/modules/searchInterfaces';

@Component({
  components: {
    SortIcon
  }
})
export default class SearchSorting extends Vue {
  @Prop(Object) sorting!: SortingOption;

  clickSortOption(property: SortingOption['property']) {
    let descending = false;

    if (this.sorting && property === this.sorting.property) {
      descending = !this.sorting.descending;
    }

    this.$emit('change', { property, descending });
  }
}
